import type { DirectoryPageMeta } from '~/modules/category/type/api';

export const getDirectoryFullName = (
    directoryMeta: DirectoryPageMeta,
): string => {
    return directoryMeta.breadcrumbs
        .slice(1) // remove the first breadcrumb (Products|Projects|Professionals)
        .map((breadcrumb) => breadcrumb.label)
        .join('/');
};
